/**
 * IPS 객체 설정 > 그룹 형태의 객체 Store
 *
 * @since 2018-06-12
 * @author kdydesign.kim
 */

// TAMS - IPS 객체 in ['서비스', '주소']
import {ObjectSecProfileApiPrefix as objApiPrefix, CmApiPrefix as cmApiPrefix} from 'utils'
import {i18n} from '~/plugins/i18n'

import {
  objectSetDataParser,
  parseAddrObjectTypeNumber,
  parseAddrObjectIpVersionType
} from 'objectSettingsUtils'

// <editor-fold desc="Util Function">
// 주소 객체 - 그룹 객체 데이터
const addressGroupData = () => {
  return {
    // TAMS
    addr_obj_uname: '',
    addr_obj_desc: '',
    mmbr_obj: [],
    cfg_layer: 1
  }
}
// </editor-fold>

export const state = () => ({
  groupDataList: [],
  addressGroupData: addressGroupData(),
  groupAddressList: [],
  addGroupInDataList: [],
  selectedData: void 0,
  selectedSubData: void 0,
  maxGroupObjectCount: 0
})

export const mutations = {
  groupClear (state) {
    state.groupDataList = []
    state.groupAddressList = []
    state.selectedData = void 0
    state.selectedSubData = void 0
  },

  // 그룹 객체 목록 조회
  setGroupObjectDataList (state, { result, rootState }) {
    const groupDataList = _.map(result, (obj) => {
      return objectSetDataParser(obj)
    })
    state.groupDataList = Object.freeze(groupDataList)
    result = Object.freeze(result)
    // state.groupDataList = Object.freeze(result)
    if (rootState) {
      const store = rootState.cm.objectSecProfile.object.ipsObjectSettings
      store.addressObject.addressObjectDataList = []
    }
  },

  // 그룹에 추가될 목록 초기화
  resetParseGroupObjDataList (state) {
    state.groupAddressList = []
  },

  // 주소 객체 그룹 추가될 목록
  parseAddressObjDataList (state, data) {
    const addressObjectDataList = _.map(_.cloneDeep(data), (obj) => {
      return objectSetDataParser(obj)
    })
    state.groupAddressList = Object.freeze(addressObjectDataList)
    data = Object.freeze(data)
  },

  // 주소 객체 저장
  saveGroupAddressData (state, {result, objectType}) {
    const groupAddressList = _.cloneDeep(state.groupAddressList)
    if (/^address\.(host\.(4|6)|network\.(4|6))$/.test(objectType)) {
      groupAddressList.unshift(objectSetDataParser(result))
    }
    state.groupAddressList = Object.freeze(groupAddressList)
  },

  // 선택된 데이터 설정
  selectGroupData (state, data) {
    state.selectedData = data
  },

  // 선택된 추가할 객체 데이터 설정
  selectGroupSubData (state, data) {
    state.selectedSubData = data
  },

  // 그룹 객체 조회
  setGroupObjectData (state, {result, groupType, rootState}) {
    const store = rootState.cm.objectSecProfile.object.ipsObjectSettings

    if (groupType.indexOf('address.group') > -1) {
      // TAMS
      const mmbrObjList = _.cloneDeep(result)
      state.addressGroupData.mmbr_obj = Object.freeze(mmbrObjList)
      store.addressObject.addressObjectDataList = Object.freeze(mmbrObjList)
    }
  },

  // 그룹 객체 포함된 객체 조회
  setAddGroupInDataList (state, {groupType, rootState}) {
    const store = rootState.cm.objectSecProfile.object.ipsObjectSettings
    let mmbrObj = void 0

    if (groupType.indexOf('address.group') > -1) {
      mmbrObj = _.clone(store.addressObject.addressObjectDataList)
    }

    state.addGroupInDataList = Object.freeze(mmbrObj)
  },

  // 그룹 객체 저장
  saveGroupObjectData (state, data) {
    const groupDataList = _.cloneDeep(state.groupDataList)
    const convertData = _.assignIn(objectSetDataParser(_.cloneDeep(data)), {
      mmbr_count: _.get(data, ['mmbr_obj', 'length'], 0)
    })
    groupDataList.unshift(convertData)

    state.groupDataList = Object.freeze(groupDataList)
    data = Object.freeze(data)
  },

  // 그룹 객체 삭제
  deleteGroupObjectData (state, {objectType}) {
    const groupDataList = _.cloneDeep(state.groupDataList)

    // define으로 뺄 것.
    const keyDict = {
      'address.group.4': 'addr_obj_id',
      'address.group.6': 'addr_obj_id'
    }

    const key = keyDict[objectType]
    const itemIndex = _.findIndex(state.groupDataList, o => {
      return o[key] === state.selectedData[key]
    })

    groupDataList.splice(itemIndex, 1)

    state.groupDataList = Object.freeze(groupDataList)
  },

  // 그룹 객체 일괄 삭제
  deleteBatchGroupObjectData (state, {items, groupType}) {
    const groupDataList = _.cloneDeep(state.groupDataList)
    let itemIndex = void 0

    _.forEach(items, (o) => {
      if (groupType.indexOf('address.group') > -1) {
        itemIndex = _.findIndex(groupDataList, {addr_obj_id: o.addr_obj_id})
      }

      groupDataList.splice(itemIndex, 1)
    })

    state.groupDataList = Object.freeze(groupDataList)
  },

  // 그룹 객체 수정
  updateGroupObjectData (state, {result, groupType, rootState}) {
    const store = rootState.cm.objectSecProfile.object.ipsObjectSettings
    const groupDataList = _.cloneDeep(state.groupDataList)
    let key = void 0

    if (groupType.indexOf('address.group') > -1) {
      key = 'addr_obj_id'
      store.addressObject.addressObjectDataList = Object.freeze(result.mmbr_obj)
    }

    const
      index = _.findIndex(state.groupDataList, {[key]: result[key]}),
      convertData = _.assignIn(objectSetDataParser(result), {
        mmbr_count: _.get(result, ['mmbr_obj', 'length'], 0)
      })
    groupDataList.splice(index, 1, convertData)

    state.groupDataList = Object.freeze(groupDataList)
  },

  // 선택한 데이터 초기화
  resetObjectSelectData (state) {
    state.selectedData = void 0
  },

  // 선택한 데이터 초기화
  resetGroupDataList (state) {
    state.groupDataList = []
  },

  // 선택한 객체 데이터 초기화
  resetObjectData (state, {rootState}) {
    const store = rootState.cm.objectSecProfile.object.ipsObjectSettings

    store.addressObject.addressObjectDataList = []
  },

  // 그룹에 포함된 객체에 추가
  addGroupInObject (state, {data, objectDataKey}) {
    const addGroupInDataList = _.clone(state.addGroupInDataList)
    data.forEach((obj) => {
      addGroupInDataList.push(obj)
    })
    state.addGroupInDataList = Object.freeze(addGroupInDataList)
    state[objectDataKey].mmbr_obj = Object.freeze(addGroupInDataList)
  },

  // 그룹 데이터 초기화
  resetGroupObjectData (state, {objectDataKey}) {
    if (objectDataKey === 'addressGroupData') {
      state.addressGroupData = addressGroupData()
    }

    state.addGroupInDataList = []
  },

  // 그룹에 포함된 객체 삭제
  removeGroupInObject (state, {type, selectedData, objectDataKey}) {
    let addGroupInDataList = _.cloneDeep(state.addGroupInDataList)
    if (type === 'single' && selectedData) {
      selectedData.forEach((data) => {
        let itemIndex = void 0

        if (objectDataKey === 'addressGroupData') {
          itemIndex = _.findIndex(state.addGroupInDataList, {addr_obj_id: data.addr_obj_id})
        }

        addGroupInDataList.splice(itemIndex, 1)
      })
    }

    if (type === 'all') {
      addGroupInDataList = []
      state.addGroupInDataList = []
      state.addressGroupData.mmbr_obj = []
    }
    state.addGroupInDataList = Object.freeze(addGroupInDataList)
    state[objectDataKey].mmbr_obj = Object.freeze(addGroupInDataList)
  },

  // 그룹에 속한 객체 초기화
  resetGroupInDataList (state) {
    state.addGroupInDataList = []
  },

  // 그룹 객체 복사
  copyGroupData (state, {objectType}) {
    const selectedData = _.cloneDeep(state.selectedData)
    const keys = Object.keys(selectedData)
    let data = null

    if (objectType.indexOf('address.group') > -1) {
      data = addressGroupData()
    }

    _.each(keys, (key) => {
      if (_.has(data, key)) {
        data[key] = selectedData[key]
      }
    })

    state.copyData = data
  },
  pasteGroupData (state, {objectType}) {
    const data = _.cloneDeep(state.copyData)
    if (objectType.indexOf('address.group') > -1) {
      state.addressGroupData = data
      state.addGroupInDataList = Object.freeze(_.get(data, ['mmbr_obj'], []))
    }
  },

  // 그룹에서 선택된 객체 초기화
  resetSelectedGroupData (state) {
    state.selectedData = void 0
  }
}

export const actions = {
  // 그룹 데이터 초기화
  resetGroupObjectData ({commit, rootState}, {objectDataKey}) {
    commit('resetGroupObjectData', {objectDataKey})
  },

  // 선택한 객체 데이터 초기화
  resetObjectData ({commit, rootState}) {
    commit('resetObjectData', {rootState})
  },

  // 그룹 객체 목록 조회
  async getGroupObjectList ({commit, state, rootState, dispatch}, {apiUrl = void 0, id = void 0, version = 4, target = void 0, loadingShow = true, loadingHide = true} = {}) {
    let url = _.isNil(apiUrl) ? `${cmApiPrefix}/objects/ips/addr-grp` : apiUrl
    // Query String 사용시 'addr'로 시작되는경우 인지를 못하여 제외함(addr_obj_ip_ver_type > obj_ip_ver_type).
    // url += _.isNil(id) ? `?obj_ip_ver_type=${parseAddrObjectIpVersionType(version)}` : `/${id}`
    url += _.isNil(id) ? `?addr_obj_ip_ver_type=${parseAddrObjectIpVersionType(version)}` : `/${id}`

    let {code, result} = await await this.$axios.$get(url, {loadingShow, loadingHide})
    if (code === 'ok') {
      commit('setGroupObjectDataList', {result, rootState})
    }
  },

  // 그룹 객체 저장
  // TAMS (forceYn 0: 중복객체 에러 리턴, 1: 중복객체 중복추가)
  async saveGroupObjectData ({commit, state, rootState, rootGetters, dispatch}, {forceYn = 0, loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.ipsObjectSettings.common.groupType
    let data = void 0
    let url = void 0

    if (groupType.indexOf('address.group') > -1) {
      const version = groupType.split('.')[2]

      // TAMS
      url = `${cmApiPrefix}/objects/ips/addr-grp`
      data = {
        addr_obj_ip_ver_type: parseAddrObjectIpVersionType(version),
        addr_obj_uname: state.addressGroupData.addr_obj_uname,
        mmbr_addr_obj_id_list: _.map(state.addressGroupData.mmbr_obj, 'addr_obj_id'),
        addr_obj_desc: _.isUndefined(state.addressGroupData.addr_obj_desc) ? '' : state.addressGroupData.addr_obj_desc,
        force_yn: forceYn
      }
    }

    // TAMS
    const res = await this.$axios.$post(url, data, {loadingShow, loadingHide, successAlert})

    // TAMS
    return res
  },

  // 그룹 객체 조회
  async getGroupObjectData ({commit, state, rootState}, {id = null, grpType = null, apiUrl = void 0, mode, loadingShow = true, loadingHide = true, path = ''} = {}) {
    const groupType = grpType || rootState.cm.objectSecProfile.object.ipsObjectSettings.common.objectType
    let url = void 0

    if (groupType.indexOf('address.group') > -1) {
      if (!id) {
        if (_.isArray(state.selectedData)) {
          id = _.last(state.selectedData).addr_obj_id
        } else {
          id = state.selectedData.addr_obj_id
        }
      }
      url = _.isNil(apiUrl) ? `${cmApiPrefix}/objects/ips/addr-grp/${id}` : `${apiUrl}-grp/${id}`
    }

    url += path

    // TAMS
    const { code, result } = await this.$axios.$get(`${url}`, {loadingShow, loadingHide})
    if (code === 'ok') {
      // TAMS
      commit('setGroupObjectData', {result, groupType, rootState, mode, path})
    }
    return {code, result}
  },

  // 그룹 객체 포함된 객체 조회
  getAddGroupInDataList ({commit, state, rootState}) {
    const groupType = rootState.cm.objectSecProfile.object.ipsObjectSettings.common.groupType

    commit('setAddGroupInDataList', {groupType, rootState})
  },

  // 그룹 객체에 포함된 자식 객체 조회(tree)
  async getChildGroupObjectData ({commit, state, rootState}, {selectedObject, loadingShow = true, loadingHide = true} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.ipsObjectSettings.common.objectType
    let
      url = `${cmApiPrefix}/objects/ips`,
      id = void 0

    if (groupType.indexOf('address.group') > -1) {
      id = selectedObject.addr_obj_id
      // TAMS
      // const
      //   addrObjType = 4, // 주소 객체 유형, 1 호스트 객체, 2 네트워크 객체 (넷마스크), 3 네트워크 객체 (범위), 4 그룹 객체 [1,2,3,4]
      //   addrObjIpVerType = parseAddrObjectIpVersionType(version) // 주소 객체 아이피 버전 유형 1 IPv4, 2 IPv6, 3 공통
      // 트리 구조 확인 필요.
      url += `/addr-grp/${id}`
    }

    // TAMS
    const {code, result} = await this.$axios.$get(url, {loadingShow, loadingHide})
    if (code === 'ok' && groupType.indexOf('address.group') > -1) {
      return result
    }
  },

  // 그룹 객체 수정
  // TAMS (forceYn 0: 중복객체 에러 리턴, 1: 중복객체 중복추가)
  async updateGroupObjectData ({commit, state, rootState, rootGetters, dispatch}, {forceYn = 0, loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.ipsObjectSettings.common.groupType
    let url = void 0,
      // id = void 0,
      data = void 0

    if (groupType.indexOf('address.group') > -1) {
      url = `${cmApiPrefix}/objects/ips/addr-grp`
      data = {
        addr_obj_uname: state.addressGroupData.addr_obj_uname,
        mmbr_addr_obj_id_list: _.map(state.addressGroupData.mmbr_obj, 'addr_obj_id'),
        addr_obj_desc: _.isUndefined(state.addressGroupData.addr_obj_desc) ? '' : state.addressGroupData.addr_obj_desc,
        addr_obj_id: state.addressGroupData.addr_obj_id,
        addr_obj_ip_ver_type: state.addressGroupData.addr_obj_ip_ver_type,
        force_yn: forceYn
      }
    }

    // TAMS
    const res = await this.$axios.$put(`${url}`, data, {loadingShow, loadingHide, successAlert})
    return res
  },

  // 그룹 객체 삭제
  async deleteGroupObjectData ({commit, state, rootState, dispatch}, {loadingShow = true, loadingHide = true} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.ipsObjectSettings.common.groupType
    let url = void 0
    let id = void 0

    if (groupType === 'serviceGroup') {
      id = state.selectedData.srv_obj_id
      url = `service-group/objects/${id}`
    }

    if (groupType.indexOf('address.group') > -1) {
      const version = groupType.split('.')[2]

      id = state.selectedData.addr_obj_id
      url = `group/${version}/objects/${id}`
    }

    let code = void 0
    let cause = void 0
    try {
      const response = await this.$axios.$delete(`${objApiPrefix}/${url}`, {isReturnError: true, loadingShow, loadingHide})
      code = _.get(response, ['code'])
      // result = _.get(response, ['result'])
    } catch (e) {
      code = _.get(e, ['data', 'code'])
      cause = _.get(e, ['data', 'message'])
    }

    if (code === 'ok') {
      const objectType = rootState.cm.objectSecProfile.object.ipsObjectSettings.common.objectType
      commit('deleteGroupObjectData', {objectType})

      commit('resetObjectSelectData')
      commit('resetObjectData', {rootState})
    } else if (Number(code) === 15010) { // 삭제 가능
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [],
        forceDelete: [_.assign(selectedData, {cause: cause})]
      }
    } else {
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [_.assign(selectedData, {cause: cause})],
        forceDelete: []
      }
    }
  },

  // 그룹 객체 일괄 삭제 - 주소 객체와 동일한 API 적용으로 상용안함.
  // async deleteBatchGroupObjectData ({commit, state, rootState, dispatch}, {forceYn = 0, loadingShow = true, loadingHide = true, successAlert = true} = {}) {
  //   let url = void 0
  //   let id = void 0
  //   // TAMS
  //   let list = void 0
  //
  //   // TAMS
  //   let objIdList = [],
  //     multiSelectedData = []
  //   const selectedData = _.cloneDeep(state.selectedData)
  //   if (_.get(selectedData, ['length'], 0) > 0) {
  //     objIdList = _.map(selectedData, id)
  //     multiSelectedData = selectedData
  //   } else {
  //     objIdList = [selectedData[id]]
  //     multiSelectedData = [selectedData]
  //   }
  //   let params = {
  //     [list]: objIdList,
  //     force_yn: forceYn
  //   }
  //   const res = await this.$axios.$put(`${objApiPrefix}/${url}`, params, {loadingShow, loadingHide, successAlert})
  //   if (res.code === 'ok') {
  //     res.result.can_not_delete = _.get(res.result, ['can_not_delete'], []).map(o => _.assign(o, _.find(multiSelectedData, [id, o[id]])))
  //     res.result.force_delete_pass = _.get(res.result, ['force_delete_pass'], []).map(o => _.assign(o, _.find(multiSelectedData, [id, o[id]])))
  //     // dispatch('common/common/setIsChanged', true, {root: true})
  //     commit('resetObjectSelectData')
  //     // commit('resetObjectData', {rootState})
  //   }
  //   return res
  // },

  // 직접 입력으로 주소 객체 추가
  async saveHostObjData ({commit, state, rootState, dispatch}, {ip, version, zone, loadingShow = true, loadingHide = true, currentTabs = 'host', ruleType, force = 0} = {}) {
    let
      nameType = void 0,
      data = void 0,
      objectType = void 0,
      autoCreateName = void 0,
      ipAddr = '',
      mask = '',
      objName = void 0
    if (ruleType === 'object') {
      autoCreateName = i18n.t('op.objectSettings_header_objectSettings')
    }
    // network object
    const netMask = Number(version) === 4 ? 32 : 128

    if (ip.indexOf('/') > -1 && Number(_.split(ip, '/')[1]) !== netMask) {
      ipAddr = _.split(ip, '/')[0]
      mask = _.split(ip, '/')[1]

      nameType = 'N'
      objectType = 'network'

      objName = `${ipAddr}_${mask}`
    } else {
      ipAddr = _.split(ip, '/')[0]

      // host object
      nameType = 'H'
      objectType = 'host'

      objName = `${ip}`
    }
    objName += `_${nameType}`

    // TAMS
    data = {
      addr_obj_uname: objName,
      addr_obj_type: parseAddrObjectTypeNumber(objectType),
      addr_obj_desc: i18n.t('cmn.autoCreateRule', {rule: autoCreateName}),
      addr_obj_ip_start_ip: ipAddr,
      addr_obj_ip_exp: mask,
      addr_obj_ip_ver_type: parseAddrObjectIpVersionType(version),
      force_yn: force
    }

    const res = await this.$axios.$post(`${cmApiPrefix}/objects`, data, {
      loadingHide,
      loadingShow
    })
    return res
  },

  // 그룹 객체 참조 여부 상세 조회
  async getGroupDetailRefData ({commit, state, rootState, dispatch}, {objectData, loadingShow = true, loadingHide = true} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.ipsObjectSettings.common.groupType
    let objId = void 0
    let url = void 0

    if (groupType.indexOf('address.group') > -1) {
      const version = groupType.split('.')[2]

      objId = objectData.addr_obj_id
      url = `group/${version}/objects`
    }

    const {code, result} = await this.$axios.$get(`${objApiPrefix}/${url}/${objId}/ref`, {loadingShow, loadingHide})

    if (code === 'ok') {
      commit('cm/objectSecProfile/object/objectSettings/common/setUsedDetailData', result, {root: true})
    }
  }
}

export const getters = {
}

export const strict = false
